module.exports = __webpack_public_path__ + "img/uigateway2fa_new.8858e66.png";